export enum NovapostCounterpartyTypeEnum {
    PRIVATE_PERSON = 'PrivatePerson',
    ORGANIZATION = 'Organization'
}
